import type { StoryFormData } from "Schemas/Stories/storyFormSchema";

/**
 * Which kind of story the form is building. Not persisted: the data model only knows the media
 * URLs, and the viewer treats any story with a video as a video story (the image is its poster).
 */
export type StoryFormat = "photo" | "video";

export const getStoryFormat = (data: StoryFormData): StoryFormat =>
  data.videoUrl.trim() !== "" ? "video" : "photo";
